export default __webpack_public_path__ + "static/media/in-contained-icon.dd7acc30.svg";